import React from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportOverallAISummaryData } from "../../../../models/FacilityReportData";

interface IOverallAISummarySectionProps {
  overallAISummary?: FacilityReportOverallAISummaryData;
}

export const OverallAISummarySection: React.FunctionComponent<
  IOverallAISummarySectionProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(
      `facilityReportsPage.facilityReportDetails.overallAISummarySection.${key}`
    );
  const { overallAISummary } = props;

  if (!overallAISummary) {
    return null;
  }

  return (
    <div className="overall-ai-summary-section white-border-panel facility-report-details-section">
      <h2>{t("title")}</h2>
      <p className="ai-summary">{overallAISummary.ai_summary}</p>
    </div>
  );
};
